import { createSelector } from 'reselect'

import { FETCH_LIMIT } from './constants'

const nvbugsSelector = state => state.project.projectNvbugs.data
const nvbugsEndSelector = state => state.project.projectNvbugs.end
const nvbugsLoadingSelector = state => state.project.projectNvbugs.loading
const tableSortSelector = state => state.project.projectNvbugs.tableSort
const tableFilterSelector = state => state.project.projectNvbugs.tableFilter

const nvbugsPagesFetchedSelector = createSelector(
  nvbugsSelector,
  (nvbugs) => Math.ceil(nvbugs.length / FETCH_LIMIT)
)

const nvbugsLoadingInitSelector = createSelector(
  nvbugsSelector,
  nvbugsLoadingSelector,
  (nvbugs, loading) => nvbugs.length === 0 && loading
)

const nvbugsLoadingRemainingSelector = createSelector(
  nvbugsSelector,
  nvbugsLoadingSelector,
  (nvbugs, loading) => nvbugs.length !== 0 && loading
) 

export {
  nvbugsSelector,
  nvbugsEndSelector,
  tableSortSelector,
  tableFilterSelector,
  nvbugsPagesFetchedSelector,
  nvbugsLoadingInitSelector,
  nvbugsLoadingRemainingSelector
}
